// extracted by mini-css-extract-plugin
export default {"button":"TournamentsCreateBanner_button","title":"TournamentsCreateBanner_title"};